import React from "react";
import { getImageUrl } from "../../Utils/localStorageUtils";

const ServiceResultCardComponent = ({ serviceData }) => {
    // Destructure the data for easy access
    const {
        _id,
        name,
        location,
        email,
        mobile,
        experience,
        companyProfile,
        selectedService,
        selectedSubServices,
        logoImage,
        serviceImages,
    } = serviceData;

    return (
        <div className="flex border rounded-lg shadow-md overflow-hidden bg-white hover:shadow-lg transition-shadow duration-300">
            {/* Left Image Section (logo) */}
                <div className="w-[24%] px-3 py-3 border">
                    <div className="relative h-auto">
                        <img
                            src={getImageUrl(logoImage) || "https://via.placeholder.com/150"}
                            onError={(e)=>e.target.src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNNLEL-qmmLeFR1nxJuepFOgPYfnwHR56vcw&s"}
                            alt="Company Logo"
                            className="rounded-md w-full h-full object-cover"
                        />
                    </div>
                </div>
            

            {/* Middle Details Section */}
            <div className="w-[56%] px-4 py-3">
                {name && <h2 className="text-lg font-medium text-[#303030] capitalize">{name}</h2>}
                {location && <p className="text-sm text-gray-600">{location}</p>}
                {email && <p className="text-xs text-gray-500">Email: {email}</p>}
                {mobile && <p className="text-xs text-gray-500">Mobile: {mobile}</p>}
                {experience && <p className="text-xs text-gray-500">Experience: {experience} years</p>}
                
                {companyProfile && (
                    <div className="mt-3">
                        <h3 className="font-semibold text-[#303030]">Company Profile:</h3>
                        <p className="text-sm text-[#606060]">{companyProfile}</p>
                    </div>
                )}

                {selectedService && (
                    <div className="mt-3">
                        <h3 className="font-semibold text-[#303030]">Service Provided:</h3>
                        <p className="text-sm text-[#606060]">{selectedService}</p>
                    </div>
                )}

                {selectedSubServices?.length > 0 && (
                    <div className="mt-3">
                        <h3 className="font-semibold text-[#303030]">Sub Services:</h3>
                        <ul className="text-sm text-[#606060] list-disc pl-5">
                            {selectedSubServices.map((service, index) => (
                                <li key={index}>{service}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* Right Service Images Section */}
            {serviceImages?.length > 0 && (
                <div className="w-[20%] text-center bg-[#f5f5f5] flex flex-col justify-between px-5 py-4">
                    <h3 className="text-lg font-semibold text-gray-800">Service Images</h3>
                    <div className="space-y-2 mt-3">
                        {/* Display only the first 3 images */}
                        {serviceImages.slice(0, 3).map((image, index) => (
                            <img
                                key={index}
                                src={getImageUrl(image)}
                                onError={(e)=>e.target.src="https://img.freepik.com/free-vector/business-workplace-design-concept-set_1284-11567.jpg?t=st=1739818763~exp=1739822363~hmac=e8b7522b8d5ff7610f47801e4e22ff038686d28c53dca5dba2ebc47ff7498e1a&w=740"}
                                alt={`Service ${index + 1}`}
                                className="w-full h-[100px] object-cover rounded-lg"
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceResultCardComponent;
